module.exports = __webpack_public_path__ + "static/media/dolly-flatbed.8e49c78a.svg";